import { ServiceTypes } from "../../../_shared/enums/service-type.enum";

export enum WorkOrderRequestStatus {
  All = 0,
  Pending = 1,
  Approved = 2,
  Rejected = 3
}

export enum WorkOrderRequestActionStatus {
  Approve = 1,
  Reject = 2,
  Reset = 3
}

// Status for Work Orders tab (execution flow)
export enum WorkOrderStatus {
  All = 0,
  Pending = 2,
  Open = 3,
  InProgress = 4,
  Completed = 5,
  Rejected = 6
}

export enum WorkOrderPriority {
  All = 0,
  Low = 1,
  Medium = 2,
  High = 3
}

export const WorkOrderRequestStatusLabels: Record<WorkOrderRequestStatus, string> = {
  [WorkOrderRequestStatus.All]: 'workOrder.status.all',
  [WorkOrderRequestStatus.Pending]: 'workOrder.status.pending',
  [WorkOrderRequestStatus.Approved]: 'workOrder.status.approved',
  [WorkOrderRequestStatus.Rejected]: 'workOrder.status.rejected'
};

export const WorkOrderStatusLabels: Record<WorkOrderStatus, string> = {
  [WorkOrderStatus.All]: 'workOrder.status.all',
  [WorkOrderStatus.Pending]: 'workOrder.status.pending',
  [WorkOrderStatus.Open]: 'workOrder.status.open',
  [WorkOrderStatus.InProgress]: 'workOrder.status.inProgress',
  [WorkOrderStatus.Completed]: 'workOrder.status.completed',
  [WorkOrderStatus.Rejected]: 'workOrder.status.rejected'
};

export const WORK_ORDER_OVERDUE_STATUS_LABEL = 'workOrder.status.overdue';

export const WorkOrderPriorityLabels: Record<WorkOrderPriority, string> = {
  [WorkOrderPriority.All]: 'workOrder.priority.all',
  [WorkOrderPriority.Low]: 'workOrder.priority.low',
  [WorkOrderPriority.Medium]: 'workOrder.priority.medium',
  [WorkOrderPriority.High]: 'workOrder.priority.high'
};

export enum WorkOrderServiceType {
  MinorService = 1,
  IntermediateService = 2,
  MajorService = 3
}

export const WorkOrderServiceTypeLabels: Record<WorkOrderServiceType, string> = {
  [WorkOrderServiceType.MinorService]: 'workOrder.serviceType.minorService',
  [WorkOrderServiceType.IntermediateService]: 'workOrder.serviceType.intermediateService',
  [WorkOrderServiceType.MajorService]: 'workOrder.serviceType.majorService'
};

export const WORK_ORDER_MISSED_SERVICE_LABEL = 'workOrder.serviceType.missedService';

export enum WorkOrderSource {
  OEM = 1,
  Custom = 2,
  System = 3,
  DriverApp = 4,
  ComplianceApp = 5,
  CanBus = 6
}

export const WorkOrderSourceLabels: Record<WorkOrderSource, string> = {
  [WorkOrderSource.OEM]: 'workOrder.source.oem',
  [WorkOrderSource.Custom]: 'workOrder.source.custom',
  [WorkOrderSource.System]: 'workOrder.source.system',
  [WorkOrderSource.DriverApp]: 'workOrder.source.driverApp',
  [WorkOrderSource.ComplianceApp]: 'workOrder.source.complianceApp',
  [WorkOrderSource.CanBus]: 'workOrder.source.canBus'
};

export const WorkOrderServiceTypesLabels: Record<ServiceTypes, string> = {
  [ServiceTypes.Minor]: 'workOrder.serviceType.minor',
  [ServiceTypes.Intermediate]: 'workOrder.serviceType.intermediate',
  [ServiceTypes.Major]: 'workOrder.serviceType.major'
};